import React from 'react'
import {
    Box,
    Typography,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useTheme,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTranslation } from 'react-i18next'
import { useSharedStyles } from '@/pages/Settings/useSharedStyles'

const accordionSections = [
    {
        sectionTitle: 'Informacje o usłudze',
        items: [
            {
                title: 'TOYA GO — jak działa usługa?',
                content:
                    'Jest to serwis, który umożliwia przede wszystkim oglądanie przez internet programów telewizyjnych w czasie rzeczywistym, na: komputerze, tablecie czy smartfonie. Oprócz programów telewizyjnych, można również korzystać z video na żądanie, karaoke, z elektronicznego przewodnika po programie TV oraz funkcji Catch-up TV / Start Over, czyli oglądania programu do 7 dni wstecz na wybranych kanałach i odtwarzania od początku programu, który już się rozpoczął.',
            },
            {
                title: 'TOYA GO — jaka jest oferta programowa?',
                content:
                    'Ofertę programową można sprawdzić na stronie go.toya.net.pl. Dostęp do programów zależy od tego, gdzie chcemy oglądać dany program — czy w domu (korzystając z sieci TOYA), czy poza domem (korzystając z internetu od innego dostawcy).',
            },
            {
                title: 'Jak zalogować się do aplikacji?',
                content:
                    'Logowanie do aplikacji dokonywane jest przy użyciu tych samych danych co logowanie do Portalu Abonenta.',
            },
            {
                title: 'Gdzie mogę zmienić ustawienia swojego konta?',
                content:
                    'Ustawienie swojego konta można zmienić w TOYA GO w menu Profil > Ustawienia.',
            },
            {
                title: 'Czy obraz z kamer nadawany na TOYA GO jest nagrywany?',
                content:
                    'Nie, obraz jest tylko strumieniowany na żywo. Ze względów technicznych przechowywane jest jedynie kilkanaście sekund każdego strumienia wideo.',
            },
        ],
    },
    {
        sectionTitle: 'TOYA GO i dekoder DTV',
        items: [
            {
                title: 'Jestem abonentem telewizji cyfrowej TOYA — czy mogę korzystać z TOYA GO?',
                content:
                    'Jak najbardziej, serwis ten dedykowany jest w szczególności dla abonentów TOYA posiadających dowolny pakiet telewizji cyfrowej TOYA. Z TOYA GO mogą również korzystać abonenci Internetu z pakietem TV Start.',
            },
            {
                title: 'Jakie są ceny za te usługi?',
                content:
                    'Dostęp do serwisu jest całkowicie bezpłatny. Opłaty pobierane są jedynie za wypożyczenie filmu z płatnej bazy VOD. Informacje o wysokości opłaty każdorazowo wyświetlają się przed wypożyczeniem.',
            },
        ],
    },
    {
        sectionTitle: 'Rozwiązania problemów',
        items: [
            {
                title: 'Mam problem z odtworzeniem filmów lub kanałów telewizyjnych. Odtwarzanie się zacina, dźwięk i obraz znacznie różnią się od pożądanych.',
                content:
                    'Wszelkiego rodzaju problemy z dostępem do usługi należy zgłaszać na naszą infolinię 426333 888 do naszego działu pomocy technicznej.',
            },
            {
                title: 'W jaki sposób mogę zgłosić problem związany z dostępnością filmu lub programu telewizyjnego?',
                content:
                    'Wszelkiego rodzaju problemy z dostępem do usługi należy zgłaszać na naszą infolinię 426333 888 do naszego działu pomocy technicznej.',
            },
            {
                title: 'Dlaczego otrzymuję komunikat „Przekroczenie zakresu licencji – Próba odtworzenia treści ze zbyt dużej ilości komputerów”?',
                content:
                    'Taki komunikat oznacza, że zalogowana jest zbyt duża ilość urządzeń, albowiem możliwość oglądania tego samego kanału w tym samym czasie jest ograniczona do dwóch urządzeń, a maksymalna ilość urządzeń, na których zalogowany może być ten sam użytkownik to 5. Dotyczy to zarówno komputera, tabletu, jak i smartfona.',
            },
        ],
    },
    {
        sectionTitle: 'Instalacja i konfiguracja',
        items: [
            {
                title: 'Skąd mogę pobrać aplikację TOYA GO?',
                content:
                    'W przypadku urządzeń mobilnych aplikację można pobrać z Google Play (dla Androida) oraz z App Store (dla iOS). Z aplikacji można również korzystać za pośrednictwem strony internetowej go.toya.net.pl.\n\nPobierz z Google Play\nPobierz z App Store\nZeskanuj kod QR',
            },
        ],
    },
]

const HelpSection: React.FC = () => {
    const { t: translate } = useTranslation()
    const theme = useTheme()
    const [expandedIndex, setExpandedIndex] = React.useState<string | null>(
        null
    )

    const { accordionStyle } = useSharedStyles()

    const handleExpansion =
        (id: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
            setExpandedIndex(isExpanded ? id : null)
        }

    return (
        <Box sx={{ marginTop: '2rem', padding: '0 1rem' }}>
            {accordionSections.map((section, sectionIdx) => (
                <Box key={sectionIdx} sx={{ marginBottom: '2rem' }}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{ color: 'white' }}>
                        {section.sectionTitle}
                    </Typography>
                    {section.items.map((item, itemIdx) => {
                        const id = `${sectionIdx}-${itemIdx}`
                        return (
                            <Accordion
                                key={id}
                                expanded={expandedIndex === id}
                                onChange={handleExpansion(id)}
                                sx={accordionStyle}>
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{ color: '#fff' }}
                                        />
                                    }
                                    aria-controls={`panel-${id}-content`}
                                    id={`panel-${id}-header`}>
                                    <Typography component="span">
                                        {item.title}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>{item.content}</Typography>
                                </AccordionDetails>
                            </Accordion>
                        )
                    })}
                </Box>
            ))}
        </Box>
    )
}

export { HelpSection }
